module.exports = __webpack_public_path__ + "img/1574431606.f63df31a.jpg";